import { render, staticRenderFns } from "./GameTargetZone.vue?vue&type=template&id=4132c665&scoped=true"
import script from "./GameTargetZone.vue?vue&type=script&lang=js"
export * from "./GameTargetZone.vue?vue&type=script&lang=js"
import style0 from "./GameTargetZone.vue?vue&type=style&index=0&id=4132c665&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4132c665",
  null
  
)

export default component.exports